import { Close } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Autocomplete, Grid, IconButton, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { getAllOrders } from "app/redux/actions/orderAction";
import axios from "axios";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import * as Yup from "yup";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: "10px",
};

export default function CancelAndDontRevertModal(props) {
    const { open, handleClose, data } = props;
    const dispatch = useDispatch()
    const validationSchema = Yup.object({
        factoryAction: Yup.string().required("Factory action is required").nullable(),
        materialType: Yup.string().when("factoryAction", {
            is: "Received from factory",
            then: Yup.string().required("Material type is required").nullable(),
        }),
        receivedQuantity: Yup.number().when("materialType", {
            is: "Raw",
            then: Yup.number().positive("Recevied quantity should not be negative").required("Recevied quantity is required").nullable(),
        }),
        // nonFactoryAction: Yup.string().when("factoryAction", {
        //     is: "Not Received from factory",
        //     then: Yup.string().required("Non-factory action is required"),
        // }),
        remark: Yup.string().when("factoryAction", {
            is: "Not Received from factory",
            then: Yup.string().required("Remark is required").nullable(),
        }),
    });

    const initialValues = {
        factoryAction: "",
        materialType: "",
        nonFactoryAction: "",
        remark: "",
        receivedQuantity: data?.order_item_fabric_required,
    };

    const factoryActionOpts = [
        "Received from factory",
        "Not Received from factory",
    ];
    const MaterialTypeOpts = ["Raw", "Finished", "Return As Same"];

    const handleSubmit = async (values) => {
        const payloadData = { ...values };
        if (payloadData?.materialType !== "Raw") {
            delete payloadData.receivedQuantity
        }
        try {
            const config = {
                withCredentials: true,
                headers: {
                    withCredentials: true,
                },
            };
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/order/cancel-before-receive-item`, { ...payloadData, order_items_id: data?.order_items_id }, config);

            if (response.status === 200) {
                handleClose();
                dispatch(getAllOrders("", "", 1));
                Swal.fire({
                    icon: "success",
                    title: "Order Cancelled Successfully",
                });
            }
        } catch (error) {
            handleClose()
            Swal.fire({
                // toast: true,
                icon: "error",
                // position: "top-right",
                text: error?.response?.data?.message,
                // showConfirmButton: false,
                // timer: 2000
            });
        }
    };


    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3">
                            Manage Order Cancellation
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </div>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ values, errors, touched, handleChange, setFieldValue, handleBlur, isSubmitting }) => (
                            <Form>
                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                    {console.log("errors => ", errors)}
                                    <Grid item xs={6}>
                                        <Typography variant="h5">Select Factory Action*</Typography>
                                        <Autocomplete
                                            // key={resetAutocomplete ? "reset1" : "normal1"}
                                            size="small"
                                            id="tags-standard"
                                            options={factoryActionOpts || []}
                                            name="factoryAction"
                                            value={values?.factoryAction}
                                            getOptionLabel={(option) => option}

                                            onChange={(e, newValue) => {
                                                setFieldValue("factoryAction", newValue);
                                                setFieldValue("materialType", "")
                                                setFieldValue("nonFactoryAction", "")
                                            }}
                                            renderOption={(props, option) => (
                                                <Box
                                                    component="li"
                                                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                                    {...props}
                                                >
                                                    {option}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    error={
                                                        Boolean(touched.factoryAction &&
                                                            errors?.factoryAction)
                                                    }
                                                    helperText={touched.factoryAction && errors.factoryAction}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    {values?.factoryAction === "Received from factory" && (
                                        <Grid item xs={6}>
                                            <Typography variant="h5">
                                                Select Material Type*
                                            </Typography>
                                            <Autocomplete
                                                size="small"
                                                id="tags-standard"
                                                name="materialType"
                                                options={MaterialTypeOpts || []}
                                                value={values?.materialType}
                                                getOptionLabel={(option) => option}
                                                onChange={(e, newValue) => {
                                                    setFieldValue("materialType", newValue);
                                                }}
                                                renderOption={(props, option) => (
                                                    <Box
                                                        component="li"
                                                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                                        {...props}
                                                    >
                                                        {option}
                                                    </Box>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        error={
                                                            Boolean(touched.materialType &&
                                                                errors?.materialType)
                                                        }
                                                        helperText={touched.materialType && errors.materialType}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    )}
                                    {values?.factoryAction === "Received from factory" && values?.materialType === "Raw" && (
                                        <Grid item xs={6}>
                                            <Typography variant="h5">Received Quantity*</Typography>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                size="small"
                                                name="receivedQuantity"
                                                value={values?.receivedQuantity}
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    const inputValue = Number(e.target.value);
                                                    const maxValue = data?.order_item_fabric_required;
                                            
                                                    if (inputValue >= maxValue) {
                                                        setFieldValue("receivedQuantity", maxValue);
                                                    }else{
                                                        setFieldValue("receivedQuantity", inputValue);
                                                    }
                                                }}
                                                error={Boolean(touched.receivedQuantity && errors.receivedQuantity)}
                                                helperText={touched.receivedQuantity && errors.receivedQuantity}
                                            />
                                        </Grid>
                                    )}
                                    {values?.factoryAction === "Not Received from factory" && (
                                        <Grid item xs={6}>
                                            <Typography variant="h5">Remark*</Typography>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                name="remark"
                                                value={values?.remark}
                                                onBlur={handleBlur}
                                                onChange={(e) =>
                                                    setFieldValue("remark", e.target.value)
                                                }
                                                error={Boolean(touched.remark && errors.remark)}

                                                helperText={touched.remark && errors.remark}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    sx={12}
                                    mt={2}
                                    display="flex"
                                    alignContent="center"
                                    justifyContent="center"
                                >
                                    <LoadingButton size="small" variant="contained" type="submit" loading={isSubmitting}>
                                        Submit
                                    </LoadingButton>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Modal>
        </div>
    );
}
